import React, {Component} from 'react';
import {Switch, Route, Redirect, withRouter} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

// Views
import Dashboard from '../../views/Dashboard/';
import Users from '../../views/Users/';
import AddUser from '../../views/Users/Add';
import AssignLocation from '../../views/locations/Assign';
import UserProfile from '../../views/Users/Profile';
import Categories from '../../views/Categories/';
import CategoryForm from '../../views/Categories/Form';
import Brands from '../../views/Brands/';
import BrandForm from '../../views/Brands/Form';
import LocationForm from '../../views/Locations/Form';
import Locations from '../../views/Locations/';
import Maps from '../../views/Locations/Maps'
import ProductForm from '../../views/Products/Form';
import Products from '../../views/Products/';
import Inventory from '../../views/Inventory/';
import InventoryForm from '../../views/Inventory/Form';
import Orders from '../../views/Orders/';
import UpdateDB from '../../views/Users/UpdateDB';

// Firebase
import { app } from '../../base';

class Full extends Component {
  constructor() {
    super();
    this.state = {
      last_login: true,
      redirect: false,
      user_type: 0
    };
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    this.saveLastLogin();
  }

  componentWillMount() {
    app.auth().onAuthStateChanged((user) => {
      if (user) {
        app.database().ref('/users/' + user.uid).once('value').then((snapshot) => {
          let snap = snapshot.val();
          let user_type = parseInt((snap && snap.user_type) || 0);
          sessionStorage.setItem("uid", user.uid);
          sessionStorage.setItem("user_type", user_type);
          if (user_type == 3) {
            sessionStorage.setItem('area', snap.area);
          }
          
          this.setState({
            authenticated: true,
            currentUser: user,
            user_type: user_type,
            redirect: false
          });
        });

        /*if (user.emailVerified === false) {
          user.sendEmailVerification().then(function() {
            //console.log("Email sent");
          }).catch(function(error) {
            //console.log(error);
          });
        }*/
      }
      else {
        sessionStorage.setItem("uid", null);
        sessionStorage.setItem("user_type", null);
        this.setState({
          authenticated: false,
          currentUser: null,
          redirect: true
        });
      }
    });
  }

  logout() {
    app.auth().signOut().then(function() {
      // Sign-out successful.
      //console.log('signed out');
    }, function(error) {
      // An error happened.
    });
  }

  render() {
    if (this.state.redirect === true) {
      return <Redirect to="/login" />
    }

    return (
      <div className="app">
        <Header logout={this.logout}/>
        <div className="app-body">
          <Sidebar user_type={this.state.user_type} {...this.props}/>
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>
                {(this.state.user_type == 1)? <Route path="/add-user" name="AddUser" component={AddUser}/>:''}
                {(this.state.user_type == 1)? <Route path="/users" name="Users" component={Users}/>:''}
                <Route path="/profile" name="UserProfile" component={UserProfile}/>
                <Route path="/orders" name="Orders" component={Orders}/>
                {(this.state.user_type == 1)? <Route path="/brands" name="Brands" component={Brands}/>:''}
                {(this.state.user_type == 1)? <Route path="/add-brand" name="AddBrand" component={BrandForm}/>:''}
                {(this.state.user_type == 1)? <Route path="/categories" name="Categories" component={Categories}/>:''}
                {(this.state.user_type == 1)? <Route path="/add-category" name="AddCategory" component={CategoryForm}/>:''}
                {(this.state.user_type == 1)? <Route path="/products" name="Products" component={Products}/>:''}
                {(this.state.user_type == 1)? <Route path="/add-product" name="AddProduct" component={ProductForm}/>:''}
                {/*((this.state.user_type == 1) || (this.state.user_type == 2)) && <Route path="/inventory" name="Inventory" component={Inventory}/>/*}
                {/*((this.state.user_type == 1) || (this.state.user_type == 2)) && <Route path="/add-inventory" name="Add Inventory" component={InventoryForm}/>*/}
                <Route path="/inventory" name="Inventory" component={Inventory}/>
                <Route path="/add-inventory" name="Add Inventory" component={InventoryForm}/>
                {(this.state.user_type == 1) && <Route path="/locations" name="Locations" component={Locations}/>}
                {(this.state.user_type == 1) && <Route path="/add-location" name="AddLocation" component={LocationForm}/>}
                {(this.state.user_type == 1) && <Route path="/assign" name="AssignLocation" component={AssignLocation}/>}
                {(this.state.user_type == 1) && <Route path="/maps" name="Maps" component={Maps}/>}
                {/*<Route path="/db_update" name="UpdateDB" component={UpdateDB}/>*/}
                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        {/*<Footer />*/}
      </div>
    );
  }

  saveLastLogin() {
    if (this.state.last_login) {
      setTimeout(()=>{
        let uid = sessionStorage.getItem("uid");
        if (uid) {
          let date = new Date();
          app.database().ref('users/' + uid).update({
            last_login: date.getTime()
          }).then(()=>{
            this.setState({
              last_login: false
            });
          });
        }
        else {
          this.saveLastLogin();
        }
      }, 1000);
    }
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js